import { toast } from "sonner-native";

/**
 * Toast utility functions to replace Alert.alert
 * For confirmations, we show a toast and the user can proceed
 * For critical confirmations, consider using a custom modal
 */
export const showToast = {
  success: (message: string) => {
    toast.success(message);
  },
  error: (message: string) => {
    toast.error(message);
  },
  info: (message: string) => {
    toast.info(message);
  },
  warning: (message: string) => {
    toast.warning(message);
  },
  // Simple message toast
  message: (message: string) => {
    toast(message);
  },
};
